import React from "react";
import { Link } from "react-router-dom";

function Take() {
  const data = [
    {
      id: 1,
      icon: "flaticon-insurance-1",
      name: "Life Insurance",
    },
    {
      id: 2,
      icon: "flaticon-insurance",
      name: "Business Insurance",
    },
    {
      id: 3,
      icon: "flaticon-health-insurance",
      name: "Health Insurance",
    },
    {
      id: 4,
      icon: "flaticon-study",
      name: "Study Insurance",
    },
    {
      id: 5,
      icon: "flaticon-insurance-3",
      name: "House Insurance",
    },
    {
      id: 6,
      icon: "flaticon-house",
      name: "Fire Insurance",
    },
  ];
  return (
    <>
      <section
        className="service-four"
        style={{
          backgroundImage: "url(assets/images/background/service-4-bg-1.jpg)",
        }}
      >
        <div className="container">
          <img
            src="assets/images/services/service-4-1.jpg"
            className="wow fadeInRight service-four__bg"
            data-wow-duration="1500ms"
          />
          <div className="row">
            <div className="col-xl-8">
              <div className="sec-title text-start">
                <p className="sec-title__tagline">insurance services</p>

                <h3 className="sec-title__title">
                  Take better insurance <br />
                  opportunity
                </h3>
              </div>

              <ul className="list-unstyled service-four__list">
                {data.map((item) => (
                  <li className="service-four__list__item" key={item.id}>
                    <div className="service-card-three">
                      <div className="service-card-three__content">
                        <div className="service-card-three__icon">
                          <i className={item.icon} />
                        </div>

                        <h3 className="service-card-three__title">
                          <Link to="/insurancesdetails">{item.name}</Link>
                        </h3>
                        <p className="service-card-three__text">
                          Take a trivial example which of us ever undertakes
                          larious physical
                        </p>
                      </div>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Take;
